import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';

export interface ITagListItem {
  tagUuid: string;
  name: string;
  useCount: number;
}

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private readonly backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
  ) {}

  createTag(accountUuid: string, name: string): Observable<{ tagUuid: string }> {
    return this.http
      .post<{ tagUuid: string }>(`${this.backendUrl}/tag/create`, { accountUuid, name })
      .pipe(
        catchError((error) => {
          return this.errorHandlingService.handleError<{ tagUuid: string }>('create_tag')(error);
        }),
      );
  }

  updateSimulationTags(accountUuid: string, callUuid: string, tagUuids: string[]): Observable<void> {
    // The endpoint doesn't answer with JSON — reading it as text stops a successful update being
    // reported as a JSON parse error.
    return this.http
      .post(`${this.backendUrl}/simulation/updateSimulationTags`, { accountUuid, callUuid, tagUuids }, { responseType: 'text' })
      .pipe(
        map(() => undefined),
        catchError((error) => {
          return this.errorHandlingService.handleError<void>('update_simulation_tags')(error);
        }),
      );
  }

  listTagsForAccount(accountUuid: string): Observable<ITagListItem[]> {
    const params = new HttpParams().set('accountUuid', accountUuid);
    return this.http
      .get<ITagListItem[]>(`${this.backendUrl}/tag/listForAccount`, { params })
      .pipe(
        catchError((error) => {
          return this.errorHandlingService.handleError<ITagListItem[]>('list_tags_for_account')(error);
        }),
      );
  }
}
